import { UpdateScenarioRequest } from "@mutiny-group/sbo-openapi-client";

import { ScenarioBuilderClient } from "@/pages/scenario-builder/api/client/scenarioClient";

export type UpdateScenarioParamsV2 = {
  scenarioBuilderClient: ScenarioBuilderClient;
  scenarioUUID: string;
  scenario: UpdateScenarioRequest;
};

export const updateScenarioV2 = ({
  scenarioBuilderClient,
  scenarioUUID,
  scenario,
}: UpdateScenarioParamsV2) => {
  return scenarioBuilderClient.scenarios.updateScenario({
    scenarioUuid: scenarioUUID,
    updateScenarioRequest: scenario,
  });
};
